export default __webpack_public_path__ + "static/media/mobile.1f14471c.png";